import React from 'react';
import { useReveal } from '../lib/useReveal';
import { CheckIcon } from '../lib/icons';
const OFFER_STACK = ['6 módulos completos', '3 guías prácticas descargables', 'Libro de trabajo diario', 'Guía completa de chakras', 'Guía de meditaciones aplicadas', 'Acceso digital inmediato', 'Acceso de por vida'];
const BONUSES = [{
  title: 'Libro de Trabajo',
  subtitle: 'Ejercicios prácticos para integrar cada nivel',
  value: '$5 USD',
  image: 'https://cdn.magicpatterns.com/uploads/aD3Rzvz9ZP5RFRn4kDkGzt/ChatGPT_Image_5_feb_2026,_16_27_39.png'
}, {
  title: 'Guía de Chakras',
  subtitle: 'Mapa completo de los centros energéticos',
  value: '$4 USD',
  image: 'https://cdn.magicpatterns.com/uploads/sPkoe46vwtSddz9EgxNRu4/ChatGPT_Image_5_feb_2026,_16_27_43.png'
}, {
  title: 'Meditaciones',
  subtitle: 'Audio-guías para tu práctica diaria',
  value: '$5 USD',
  image: 'https://cdn.magicpatterns.com/uploads/5aZmLeTL5kP6YtJeo4ys2w/ChatGPT_Image_5_feb_2026,_16_48_24.png'
}];
export function BonusesSection() {
  const [ref1, vis1] = useReveal();
  const [ref2, vis2] = useReveal();
  return <section className="bg-[#0f0f1a] py-14 md:py-20 px-4 relative overflow-hidden border-t border-white/5" data-id="element-50">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-51">
        <div className="absolute top-0 left-1/4 w-[500px] h-[500px] bg-[#d4a017]/5 rounded-full blur-[120px]" data-id="element-52"></div>
        <div className="absolute bottom-0 right-1/4 w-[400px] h-[400px] bg-[#c82333]/5 rounded-full blur-[100px]" data-id="element-53"></div>
      </div>

      <div className="container mx-auto max-w-6xl relative z-10" data-id="element-54">
        {/* Header */}
        <div ref={ref1} className={`reveal text-center mb-10 ${vis1 ? 'is-visible' : ''}`} data-id="element-55">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-white mb-4 leading-tight" data-id="element-56">
            🎁 BONOS INCLUIDOS
          </h2>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6 text-lg md:text-xl text-gray-300" data-id="element-57">
            <span data-id="element-58">Libro de trabajo de Reiki</span>
            <span className="hidden sm:inline text-[#d4a017]" data-id="element-59">·</span>
            <span data-id="element-60">Guía completa de los 7 chakras</span>
            <span className="hidden sm:inline text-[#d4a017]" data-id="element-61">·</span>
            <span data-id="element-62">Guía práctica de meditación</span>
          </div>
        </div>

        {/* Bonuses Grid */}
        <div ref={ref2} className={`reveal grid grid-cols-1 md:grid-cols-3 gap-6 mb-12 justify-items-center ${vis2 ? 'is-visible' : ''}`} data-id="element-63">
          {BONUSES.map((bonus, idx) => <div key={idx} className="group relative bg-[#1e1e30] rounded-2xl p-6 border border-white/10 hover:border-[#d4a017]/50 transition-all duration-300 hover:-translate-y-2 hover:shadow-[0_20px_40px_-15px_rgba(212,160,23,0.15)] w-full max-w-sm mx-auto shadow-sm" data-id="element-64">
              {/* Badge */}
              <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gradient-to-r from-[#d4a017] to-[#b8860b] text-[#0f0f1a] text-xs font-bold px-4 py-1.5 rounded-full shadow-lg z-20 whitespace-nowrap" data-id="element-65">
                BONO #{idx + 1} · GRATIS
              </div>

              {/* Image */}
              <div className="relative mb-6 rounded-xl overflow-hidden h-48 md:h-44 group-hover:shadow-lg transition-all" data-id="element-66">
                <div className="absolute inset-0 bg-gradient-to-t from-[#0f0f1a]/80 to-transparent z-10" data-id="element-67"></div>
                <img src={bonus.image} alt={bonus.title} className="w-full h-full object-cover object-center transform group-hover:scale-105 transition-transform duration-700" data-id="element-68" />
              </div>

              {/* Content */}
              <div className="text-center flex flex-col items-center" data-id="element-69">
                <h3 className="text-2xl font-serif font-bold text-white mb-2 group-hover:text-[#f0c040] transition-colors" data-id="element-70">
                  {bonus.title}
                </h3>
                <p className="text-gray-400 text-sm mb-4 min-h-[40px]" data-id="element-71">
                  {bonus.subtitle}
                </p>
                <div className="flex items-center justify-center gap-3 text-sm" data-id="element-72">
                  <span className="text-gray-500 line-through decoration-[#d4a017]/50" data-id="element-73">
                    Valor: {bonus.value}
                  </span>
                  <span className="text-[#f0c040] font-bold uppercase tracking-wide" data-id="element-74">
                    HOY: GRATIS
                  </span>
                </div>
              </div>
            </div>)}
        </div>

        {/* Total Value & List */}
        <div className="max-w-4xl mx-auto bg-[#1e1e30] rounded-3xl p-6 md:p-10 shadow-lg relative overflow-hidden border border-white/10" data-id="element-75">
          <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-[#d4a017] via-[#f0c040] to-[#d4a017]" data-id="element-76"></div>

          <div className="text-center mb-6" data-id="element-77">
            <h3 className="text-2xl md:text-3xl font-serif font-bold text-white mb-2" data-id="element-78">
              Resumen de todo lo que te llevas:
            </h3>
            <p className="text-gray-400" data-id="element-79">
              Acceso inmediato a la plataforma + todos los bonos
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-4" data-id="element-80">
            {OFFER_STACK.map((item, idx) => <div key={idx} className="flex items-start gap-3" data-id="element-81">
                <div className="mt-1 flex-shrink-0 bg-[#d4a017]/20 p-1 rounded-full" data-id="element-82">
                  <CheckIcon className="w-4 h-4 text-[#f0c040]" strokeWidth={3} data-id="element-83" />
                </div>
                <span className="text-lg text-gray-200 font-medium leading-tight" data-id="element-84">
                  {item}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}